module.exports = __webpack_public_path__ + "img/icon-del2.179f33c4.png";